import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, IconButton } from "@material-ui/core";
import Title from "components/Admin/Title/Title";
import { useStyles } from "features/admin/styles";
import { MdRefresh, MdSave, MdChevronLeft } from "react-icons/md";
import { useForm } from "react-hook-form";
import {
  Form,
  ProgressBar,
  SubmitButton,
  TitleContainer,
  Zone,
  BorderLinearProgress,
  FIELDS,
} from "components/Admin/InputFields/utils";
import { useNavigate } from "react-router-dom";
import Preloader from "components/Preloader/Preloader";
import styled from "styled-components";
import ImageField, { Content } from "components/Admin/InputFields/ImageField";
import TextInputField from "components/Admin/InputFields/TextInputField";
import { selectResponse } from "features/admin/adminSlice";
import SelectField from "components/Admin/InputFields/SelectField";
interface AccessoryFormProps {
  formTitle: string;
  onSubmit: (data: any) => void;
  fields: any;
  progress: number;
}

const AccessoryForm: React.FC<AccessoryFormProps> = ({ formTitle, onSubmit, fields, progress }) => {
  const [resetForm, setResetForm] = useState(false);
  const classes = useStyles();
  const { handleSubmit, setValue, control, errors } = useForm();
  const formRef = useRef<HTMLFormElement>(null);
  const isEditPage = window.location.pathname.includes("edit");
  const response = useSelector(selectResponse);
  const navigate = useNavigate();

  const createEmptyImage = (id: number): Content => {
    return {
      id: id,
      name: fields.data[0].name,
      file_name: undefined,
      contentType: undefined,
      image: undefined,
      is_main_image: false,
    };
  };
  const [image, setImage] = useState<Content>(createEmptyImage(0));

  useEffect(() => {
    setImage(createImageState(0, fields.data[0].value));
  }, []);

  useEffect(() => {
    if (response && response.hasError) {
      reset();
    }
  }, [response]);

  const createImageState = (id: number, res?: Content): Content => {
    return res
      ? {
          id: id,
          name: fields.data[0].name, //TODO
          file_name: res.file_name,
          contentType: res.contentType,
          image: res.image,
          is_main_image: false,
        }
      : createEmptyImage(id);
  };
  const reset = () => {
    setResetForm(!resetForm);
  };
  const renderFields = (data: any) => {
    const textFields = data.slice(2);
    return (
      <>
        <Wrapper>
          <ImageField
            content={image}
            control={control}
            reset={resetForm}
            required={false}
            setValue={setValue}
            maxSizeBytes={3000000}
          />
        </Wrapper>
        <SelectField item={data[1]} control={control} reset={resetForm} setValue={setValue} />
        {textFields.map((field: any, idx: number) => {
          const FieldComponent = FIELDS[field.type] || TextInputField;
          return (
            <FieldComponent
              key={idx}
              item={field}
              control={control}
              reset={resetForm}
              setValue={setValue}
              errors={errors}
            />
          );
        })}
      </>
    );
  };

  return (
    <>
      <TitleContainer>
        <IconButton aria-label="Назад" onClick={() => navigate(-1)}>
          <MdChevronLeft />
        </IconButton>
        {!isEditPage && (
          <IconButton aria-label="Обнови" onClick={reset}>
            <MdRefresh />
          </IconButton>
        )}

        <Title>{formTitle}</Title>
      </TitleContainer>
      <p>
        Мета заглавие (дължина): 20 - 60 знака
        <br />
        Мета тагове (брой): 4 - 9 тага
        <br />
        Мета описание (дължина): 50 - 160 знака
      </p>
      <Form ref={formRef} onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <Grid container spacing={1}>
          {fields ? (
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={12}>
                <Zone className={classes.paper}>{renderFields(fields.data)}</Zone>
              </Grid>
            </Grid>
          ) : (
            <LoaderContainer>
              <Preloader />
            </LoaderContainer>
          )}
        </Grid>
        <ProgressBar>
          <BorderLinearProgress variant="determinate" value={progress} />
        </ProgressBar>
        <SubmitButton
          disabled={progress !== 0 && progress !== 100}
          variant="contained"
          color="primary"
          type="submit"
          startIcon={<MdSave size="1.5rem" />}
        >
          Запази
        </SubmitButton>
      </Form>
    </>
  );
};
const LoaderContainer = styled.div`
  width: 100%;
  margin: 30px 0;
`;
const Wrapper = styled.div`
  width: 200px;
`;
export default AccessoryForm;
